import { useEffect } from "react";

import debounce from "@utils/debounce";

import useOrderFormik from "../useOrderFormik";
import useOrderStorage from "./useOrderStorage";

const debouncedDataStore = debounce((func) => func());

const useStoreOrderData = (): void => {
  const { values } = useOrderFormik();

  const { storeData } = useOrderStorage();

  useEffect(() => {
    debouncedDataStore(() => {
      storeData(values);
    });
  }, [storeData, values]);
};
export default useStoreOrderData;
